import { Button, ButtonGroup, Card, CircularProgress } from "@mui/material";
import module from "./InvitationCard.module.css";
import { QRCodeCanvas } from "qrcode.react";
import { useEffect, useState } from "react";
import { Auth } from "aws-amplify";
import LinkIcon from "@mui/icons-material/Link";
import GetAppSharpIcon from "@mui/icons-material/GetAppSharp";
import ReplySharpIcon from "@mui/icons-material/ReplySharp";
import { Link } from "react-router-dom";
import CreateQrUrl from "../../util/createQrUrl";

export default function InvitationCard() {
  const [sub, setSub] = useState(null);
  const accountUrl = CreateQrUrl(sub);

  const getUserInfo = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      setSub(user.attributes.sub);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getUserInfo();
  }, []);

  const EachButton = ({ text, icon, handleClick }) => {
    return (
      <Button
        sx={{
          fontSize: "11px",
          width: "105px",
          fontWeight: "bold",
        }}
        onClick={handleClick}
      >
        <div>
          <div>{icon}</div>
          <div>{text}</div>
        </div>
      </Button>
    );
  };

  const handleClickCopy = async () => {
    try {
      await navigator.clipboard.writeText(accountUrl);
    } catch (error) {
      console.log(error);
    }
  };

  const handleClickDownload = () => {
    const canvas = document.getElementById("account_qr");
    const a = document.createElement("a");
    a.href = canvas.toDataURL("image/png");
    a.download = "account_qr.png";
    a.click();
  };

  const handleClickShare = () => {
    try {
      const shareData = {
        title: "nosh紹介QRコード",
        text: "手軽にヘルシーな食事ナッシュはコチラ",
        url: accountUrl,
      };

      if (navigator.share && navigator.canShare(shareData)) {
        navigator.share(shareData);
      } else {
        alert("申し訳ありませんが、このブラウザではシェアできません。");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const isMacAndChrome =
    navigator.platform === "MacIntel" &&
    navigator.userAgent.indexOf("Chrome") !== -1;

  return (
    <Card
      sx={{
        margin: "16px 0px",
        maxWidth: "640px",
        padding: "15px 0px",
        borderRadius: "8px",
        boxShadow: "0px 0px 4px 0px rgba(0, 0, 0, 0.15)",
        "@media (max-width: 640px)": {
          margin: "16px 16px 32px 16px",
        },
      }}
    >
      <div className={module.warpCardTitle}>
        <div className={module.cardTitle}>お客様専用紹介カード</div>
      </div>
      <div>
        <div>
          <span className={module.contentSub}>
            QRコードやリンクを使って、お友達に紹介しよう！
          </span>
        </div>
        <div className={module.wrapQr}>
          {sub ? (
            <QRCodeCanvas value={accountUrl} size={100} id="account_qr" />
          ) : (
            <CircularProgress color="success" />
          )}
        </div>
        <div className={module.wrapButton}>
          <Button
            variant="outlined"
            sx={{
              fontSize: "12px",
              fontWeight: "bold",
              color: "#15B855",
              borderColor: "#15B855",
              padding: "8px 16px",
            }}
            LinkComponent={Link}
            to={"qr"}
          >
            友達に見せる
          </Button>
        </div>
        <div className={module.wrapButtonGroup}>
          <ButtonGroup
            variant="contained"
            aria-label="outlined primary button group"
          >
            <EachButton
              text="リンクをコピー"
              icon={<LinkIcon />}
              handleClick={handleClickCopy}
            />
            <EachButton
              text="ダウンロード"
              icon={<GetAppSharpIcon />}
              handleClick={handleClickDownload}
            />
            {!isMacAndChrome && (
              <EachButton
                text="シェア"
                icon={<ReplySharpIcon className={module.shareIcon}/>}
                handleClick={handleClickShare}
              />
            )}
          </ButtonGroup>
        </div>
      </div>
    </Card>
  );
}
